import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { FloatingConfiguratorComponent } from '../../layouts/internal/components/floating-configurator.component';

@Component({
  selector: 'app-notfound',
  standalone: true,
  imports: [RouterModule, ButtonModule, FloatingConfiguratorComponent],
  templateUrl: './notfound.component.html',
})
export class NotfoundComponent {}
